import { Button } from 'antd';
import React, { useState, useEffect } from 'react';

import logicOperators from '../../../../utils/logicOperators';
import { FormWrapper, NumberField, Select } from '../../../../WidgetConfiguratorComponents/FormGroups';
import { LeftButton, RightButton, StyledBlueBox } from './ThresholdEditor.style';

interface Threshold {
    value: number;
    operator: string;
    itemId: string | null;
    threatLimitId: string | null;
}

interface ThresholdEditorProps {
    threshold: Threshold;
    threatLimits: { id: string; label: string }[];
    onSave(threshold: Threshold): void;
    onCancel(): void;
}

const ThresholdEditor: React.FC<ThresholdEditorProps> = ({ threshold, threatLimits, onSave, onCancel }) => {
    const defaultState: Threshold = {
        value: 2,
        operator: 'greaterThan',
        itemId: null,
        threatLimitId: null,
    };

    const [thresholdState, setThresholdState] = useState<Threshold>({
        ...defaultState,
        ...threshold,
    });

    useEffect(() => {
        setThresholdState(threshold ? threshold : defaultState);
    }, [threshold]);

    const updateState =
        <T extends keyof Threshold>(key: T) =>
        (value: Threshold[T]) => {
            setThresholdState({
                ...thresholdState,
                [key]: value,
            });
        };

    const appearanceValues = threatLimits.map(({ id: value, label }) => ({ value, label }));

    const onSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        onSave(thresholdState);
    };

    const submitDisabled = isNaN(thresholdState.value) || !thresholdState.operator || !thresholdState.itemId || !thresholdState.threatLimitId;

    return (
        <StyledBlueBox>
            <form onSubmit={onSubmitForm}>
                <FormWrapper>
                    <Select values={Object.keys(logicOperators)} value={thresholdState.operator} label='Logic Operator' onChange={updateState('operator')} />
                    <NumberField value={thresholdState.value} label='Limit' onChange={updateState('value')} required step='any' />
                    <Select label='Appearance' value={thresholdState.threatLimitId} values={appearanceValues} onChange={updateState('threatLimitId')} />
                    <LeftButton>
                        <Button htmlType='submit' type='primary' disabled={submitDisabled}>
                            Save
                        </Button>
                    </LeftButton>
                    <RightButton>
                        <Button htmlType='reset' type='dashed' onClick={() => onCancel()}>
                            Cancel
                        </Button>
                    </RightButton>
                </FormWrapper>
            </form>
        </StyledBlueBox>
    );
};

export default ThresholdEditor;
export { Threshold };
